import { render, staticRenderFns } from "./StepDescription.vue?vue&type=template&id=1421e1ee&"
import script from "./StepDescription.vue?vue&type=script&lang=js&"
export * from "./StepDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports